export type BizType = "physique" | "online" | "mixte";

export const BIZ_TYPE_VALUES: BizType[] = ["physique", "online", "mixte"];

export function parseBizTypeFromQuery(raw: string | null): BizType | null {
  if (raw && BIZ_TYPE_VALUES.includes(raw as BizType)) {
    return raw as BizType;
  }
  return null;
}

export const BIZ_OPTIONS: {
  id: BizType;
  emoji: string;
  titleKey: string;
  descKey: string;
}[] = [
  { id: "physique", emoji: "🏬", titleKey: "commercants.biz.physique.title", descKey: "commercants.biz.physique.desc" },
  { id: "online", emoji: "🛒", titleKey: "commercants.biz.online.title", descKey: "commercants.biz.online.desc" },
  { id: "mixte", emoji: "🔀", titleKey: "commercants.biz.mixte.title", descKey: "commercants.biz.mixte.desc" },
];

const BIZ_TITLE_KEYS: Record<BizType, string> = {
  physique: "commercants.biz.physique.title",
  online: "commercants.biz.online.title",
  mixte: "commercants.biz.mixte.title",
};

export function getBizTypeLabel(biz: BizType, t: (key: string) => string): string {
  return t(BIZ_TITLE_KEYS[biz]);
}
